import { DispatchToCustomer, DispatchItemsDto, Constants } from '../../../../../core';
export const dispatchToCustomer = {
  hasDisabledCheckBoxItem: (row: DispatchToCustomer, selection: DispatchToCustomer[], data: any) => {
    if (row && row.dispatchItemsDto) {
      let countStateDispatch = 0;
      row.dispatchItemsDto.forEach((item: DispatchItemsDto) => {
        if (!item.stateDispatch
          || (item.canceledAmount === item.totalAmount)
          || (item.state && item.state.toUpperCase() === Constants.DISPATCH_STATUS_LIST.CANCELLED.text)
          // || (item.notPickingWms && item.state && item.state.toUpperCase() === Constants.DISPATCH_STATUS_LIST.PENDING_PICKING.text)
          || (item.totalAmount < 0
            || item.processedAmount < 0
            || item.pendingAmount < 0)
        ) {
          countStateDispatch++;
        }
      });

      if (countStateDispatch === row.dispatchItemsDto.length) {
        if (data) {
          data.deselect(row);
        }
        return true;
      } else {
        return false;
      }
    }
    return false;
  },
  searchText: 'Buscar despacho',
  export: false,
  sort: true,
  dialogHability: true,
  filter: false,
  checkbox: true,
  paginator: true,
  exportFile: 'despacho_clientes.xlsx',
  expandable: true,
  disabled: false,
  partialField: '',
  iconsOfActions: [
    // { icon: 'operations', tooltip: 'Crear viaje' }
    { icon: 'add-dispatch', tooltip: 'Agregar despachos a lista' }
  ],
  columns: [
    {
      title: 'Empresa',
      name: 'companyCode',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.companyCode
    },
    {
      title: 'N° de NV',
      name: 'saleNoteId',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.saleNoteId
    },
    {
      title: 'N° de despacho',
      name: 'dispatchId',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchId
    },
    {
      title: 'Dirección de Entrega',
      name: 'deliveryAddress',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.deliveryAddress ? element.deliveryAddress.split('$%$').join(' ') : ''
    },
    {
      title: 'Distrito',
      name: 'dispatchDistrict',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.dispatchDistrict
    },
    {
      title: 'Zona de despacho',
      name: 'dispatchZone',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchToCustomer) => element.dispatchZone
    },
    {
      title: 'Entidad Actual',
      name: 'currentEntityName',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.currentEntityName
    },
    {
      title: 'Entidad de Venta',
      name: 'saleLocationName',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.saleLocationName
    },
    {
      title: 'Fecha original de entrega',
      name: 'originalDeliveryDate',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.originalDeliveryDate
    },
    {
      title: 'Fecha de entrega',
      name: 'deliveryDate',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.deliveryDate
    },
    {
      title: 'Inicio ventana horaria',
      name: 'startDateDeliveryWindow',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.startDateDeliveryWindow
    },
    {
      title: 'Fin ventana horaria',
      name: 'endDateDeliveryWindow',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.endDateDeliveryWindow
    },
    {
      title: 'Documento de Cliente',
      name: 'customerDocumentNumber',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.customerDocumentNumber
    },
    {
      title: 'Nombre de Cliente',
      name: 'customer',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.customer
    },
    {
      title: 'Teléfono de Cliente',
      name: 'telephone',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.telephone
    },
    {
      title: 'Tipo de despacho',
      name: 'dispatchTypeName',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'left',
      class: 'confirmationDispatches',
      value: (element: DispatchToCustomer) => element.dispatchTypeCode
    },
    {
      title: 'VTEX',
      name: 'vtexCode',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchToCustomer) => element.vtexCode
    },
    {
      title: 'Agrupación de entidad origen',
      name: 'originEntityGroupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchToCustomer) => element.originEntityGroupName
    },
    {
      title: 'Agrupación de entidad actual',
      name: 'groupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchToCustomer) => element.groupName
    },
    {
      title: 'Agrupación de entidad siguiente',
      name: 'nextEntityGroupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchToCustomer) => element.nextEntityGroupName
    },
    {
      title: 'Agrupación de entidad final',
      name: 'finalEntityGroupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchToCustomer) => element.finalEntityGroupName
    },
    {
      title: 'Entidad Final',
      name: 'finalEntityCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchToCustomer) => element.finalEntityCode
    },
    {
      title: '',
      type: 'button',
      name: 'map',
      editable: false,
      checkAll: false,
      class: 'center',
      value: () => {
        return {
          icon: 'room',
          tooltip: 'Ver ubicación',
          class: 'recordColumn icon-table'
        };
      }
    }
  ]
};
